import { render } from "./offersDetails.vue?vue&type=template&id=3d7128fe"
import script from "./offersDetails.vue?vue&type=script&lang=js"
export * from "./offersDetails.vue?vue&type=script&lang=js"

import "./offersDetails.vue?vue&type=style&index=0&id=3d7128fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/offersDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d7128fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d7128fe', __exports__)) {
    api.reload('3d7128fe', __exports__)
  }
  
  module.hot.accept("./offersDetails.vue?vue&type=template&id=3d7128fe", () => {
    api.rerender('3d7128fe', render)
  })

}


export default __exports__